import React, { useEffect, useState } from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Link from "@mui/material/Link";
import Box from "@mui/material/Box";
import TherapistCardInfo from "../../components/TherapistCardInfo";
import PostCard from "../../components/PostCard";
import { colleagues, treatment_program } from "../../constants/common";
import VerificationModal from "../../components/VerificationModal";
import paths from "../../constants/paths";
import { useParams } from "react-router-dom";
import { getPost } from "../../services/home.services";
import { useAlert } from "../../contexts/Alert";
import UserVerticalCard from "../../components/UserVerticalCard";
import { useNotifcations } from "../../contexts/Notifications";
import { useHomePage } from "../../contexts/HomePage";
import { Skeleton } from "@mui/material";
import { useAuth } from "../../contexts/Auth";
import { useNetwork } from "../../contexts/NetWork";

const SpecificPostPage = () => {
  const { post_id, comment_id } = useParams();
  const { sendAlert } = useAlert();
  const [currentPost, setCurrentPost] = useState(null);
  const { account_type } = useAuth();
  const [loading, setLoading] = useState(true);
  const { connectStatus, updateNetworkState } = useNetwork();

  const {
    fetchSinglePost,
    updateHomePagetate,
    fetchSuggestedPeople,
    suggestPeople,
    fetchSuggestPeopleStatus,
    posts,
  } = useHomePage();

  useEffect(() => {
    fetchSinglePostData();
  }, [post_id, comment_id]);

  useEffect(() => {
    if (!comment_id || !posts?.data?.length) return;

    const timeout = setTimeout(() => {
      const commentEl = document.getElementById(`comment-${comment_id}`);
      const replyEl = document.getElementById(`reply-${comment_id}`);

      const target = commentEl || replyEl;
      if (target) {
        target.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }, 500);

    return () => clearTimeout(timeout);
  }, [posts, comment_id]);

  useEffect(() => {
    fetchSuggestedPeople(account_type === treatment_program ? treatment_program : "user");
  }, [account_type]);

  useEffect(() => {
    if (connectStatus === "SUCCESS") {
      fetchSuggestedPeople(account_type === treatment_program ? treatment_program : "user");
      updateNetworkState && updateNetworkState('connectStatus', '');
    }
  }, [connectStatus, account_type, updateNetworkState]);

  useEffect(() => {
    if (post_id && comment_id) {
      getPost({ account_type, post_id })
        .then((res) => {
          const post = res.data.data;

          updateHomePagetate("posts", {
            data: [post],
            last_page: 1,
            per_page: 1,
          });
        })
        .catch((error) => {
          sendAlert(error.response?.data?.message, "error");
        });
    } else if (post_id) {
      getPost({ account_type, post_id })
        .then((res) => {
          const post = res.data.data;

          updateHomePagetate("posts", {
            data: [post],
            last_page: 1,
            per_page: 1,
          });
        })
        .catch((error) => {
          sendAlert(error.response?.data?.message, "error");
        });
    }
  }, [post_id]);

  // Find the current post from posts data and set loading state
  useEffect(() => {
    if (posts?.data?.length > 0) {
      const foundPost = posts.data.find((p) => p.id == post_id);
      setCurrentPost(foundPost || null);
      setLoading(false);
    } else if (posts?.data?.length === 0) {
      // Posts loaded but no data found
      setCurrentPost(null);
      setLoading(false);
    }
  }, [posts, post_id]);

  const postUser = currentPost?.user;
  const byTreatmentProgram = currentPost?.by_treatment_program || false;
  const isLoadingSuggested = fetchSuggestPeopleStatus === "LOADING";
  const fetchSinglePostData = () => {
    if (post_id) {
      fetchSinglePost({ account_type, post_id, comment_id });
    }
  }

  return (
    <Container>
      <Grid container spacing={{ xs: 0, md: 3 }}>
        <Grid item xs={12} md={2.5}>
          <Box
            sx={{
              position: "sticky",
              top: 80,
              display: "flex",
              flexDirection: "column",
              gap: 2.5,
            }}
          >
            {postUser && <TherapistCardInfo data={postUser} byTreatmentProgram={byTreatmentProgram} fetchSinglePostData={fetchSinglePostData} />}
          </Box>
        </Grid>
        <Grid
          item
          xs={12}
          md={7}
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            {!loading && currentPost ? (
              <PostCard data={currentPost} />
            ) : (
              <Paper
                sx={{
                  boxShadow: "none",
                  borderColor: "border.main",
                  p: 3,
                  display: "flex",
                  flexDirection: "column",
                  gap: 2,
                }}
              >
                <Skeleton variant="text" width="60%" height={32} />
                <Skeleton variant="text" width="40%" height={24} />
                <Skeleton variant="rectangular" height={200} />
                <Skeleton variant="text" width="50%" height={28} />
              </Paper>
            )}
          </Box>

          <Paper
            sx={{
              boxShadow: "none",
              borderColor: "border.main",
              p: 3,
              display: "flex",
              flexDirection: "column",
              gap: 2,
            }}
          >
            {isLoadingSuggested ? (
              <>
                <Skeleton variant="rectangular" height={60} sx={{ mb: 1 }} />
                <Skeleton variant="rectangular" height={60} sx={{ mb: 1 }} />
                <Skeleton variant="rectangular" height={60} sx={{ mb: 1 }} />
              </>
            ) : suggestPeople.length > 0 ? (
              suggestPeople.map((item) => (
                <UserVerticalCard key={item.id} data={item} />
              ))
            ) : (
              <Box sx={{ color: 'text.secondary', py: 2, textAlign: 'center' }}>
                No suggested people found.
              </Box>
            )}
            <Link
              href={paths.network(colleagues)}
              variant="body1"
              color="primary"
            >
              Find more specialized therapists
            </Link>
          </Paper>
        </Grid>
      </Grid>
      <VerificationModal />
    </Container>
  );
};

export default SpecificPostPage;
